import React, { useState,useEffect } from 'react'
import {getCountries,getClasses} from '../../actions/RegisterAction';
import {getCountryCode} from '../../actions/StudentAction'
import { saveReferalDetail } from '../../actions/ReferralAction';
import swal from 'sweetalert';
import { StateUseContext } from '../../context/UserDetailContext';

const ReferalForm = () => {
    const [loading, setLoading] = useState(false);
    const {fetchReferalDetail} = StateUseContext();
    const [form, setForm] = useState({ country: '', name: '', email: '', mobileNumber: '', countryCode:'', class: '', school: '' })
    const [countries,setCountries] = useState([])
    const [classes,setClasses] = useState([])
    const [countryCode,setCountryCode] = useState([])
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const countryList = async() => {
            try {
                await getCountries().then((res) =>{
                    setCountries(res.data)
                })
            } catch (error) {
                console.log('country error',error)
            }
        }

        const classesList = async() => {
            try {
                await getClasses().then((res) =>{
                    setClasses(res.data)
                })
            } catch (error) {
                console.log('classes error',error)
            }
        }

        countryList()
        classesList()
        
    },[])
 
    const handleFormChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
        setErrors({ ...errors, [e.target.name]: '' });

        if(e.target.name ==='country'){
            let cVal = e.target.value;
            fetchCountryCode(cVal)
        }
    }

    const fetchCountryCode = async(cId) => {
        try {
            await getCountryCode(cId).then((res) => {
                if(res.status){
                    setCountryCode(res.data)
                }
            })
        } catch (error) {
            console.log('code err',error)
        }   
    }

    const validateEmailLength = (email) => {
        const atIndex = email.indexOf('@');
        const lengthBeforeAt = atIndex === -1 ? email.length : atIndex;
        return lengthBeforeAt >= 3 && lengthBeforeAt <= 64;
    };

    const validateEmailFormat = (email) => {
        const pattern = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
        return pattern.test(email);
    };

    const validation = () => {
        let formIsFalse = true;
        const newErrors = {};
        const requiredFields = ['country', 'name', 'class', 'school', 'mobileNumber', 'email'];
        const email = form.email;

        requiredFields.forEach((field) => {
            if (!form[field]) {
                formIsFalse = false;
                newErrors[field] = `Please provide ${field === 'email' ? 'an' : 'a'} ${field}`;
            }
        });

        if (!validateEmailLength(email)) {
            formIsFalse = false;
            newErrors.email = 'Email must be between 3 and 64 characters';
        }

        if (!validateEmailFormat(email)) {
            formIsFalse = false;
            newErrors.email = 'Enter a valid Email ID (Ex: abc@gmail.com)';
        }

        setErrors(newErrors);
        return formIsFalse;
    };


    const formSubmitHandler = async(e) => {
        e.preventDefault();
        if (validation()) {
            setLoading(true)
            const data = {
                country_id:form.country,
                student_name:form.name,
                student_email:form.email,
                phone_number:form.mobileNumber,
                country_code:countryCode[0]?.isd_code,
                class_id:form.class,
                school:form.school,
            }
            try {
                await saveReferalDetail(data).then((res) => {
                    if(res.status){
                        setLoading(false)
                        fetchReferalDetail()
                        swal('Referral details submitted.','','success')
                        setForm({ country: '', name: '', email: '', mobileNumber: '', countryCode:'', class: '', school: '' })
                    }
                    else{
                        swal(res.message,'','error')
                    }
                })
            } catch (error) {
                console.log(error,'','error')
            }
            
        }
    }



    return (
        <form onSubmit={formSubmitHandler} className='row g-x-3 referral_form'>
            <div className="col-lg-6 mb-3">
                <label className="form-label">Country<span>*</span></label>
                <select name="country" value={form.country} onChange={handleFormChange} className='form-select'>
                    <option value="">Select country</option>
                    {countries?.map((countryItem) =>  <option key={countryItem.id} value={countryItem.id}>{countryItem.name}</option>)}
                </select>
                {errors.country && <small className="invalid-field text-danger fw-semibold mt-2">{errors.country}</small>}

            </div>

            <div className="col-lg-6 mb-3 mt-3 mt-lg-0">
                <label className="form-label">Student Full Name<span>*</span></label>
                <input type="text"
                    name="name"
                    value={form.name}
                    onChange={handleFormChange}
                    className="form-control"
                    placeholder="Student Name"
                />
                {errors.name && <small className="invalid-field text-danger fw-semibold mt-2">{errors.name}</small>}

            </div>
            {/* Student Email */}
            <div className="col-md-6 mb-3">
                <label className="form-label">Student Email<span>*</span></label>
                <input type="email" name='email' value={form.email} onChange={handleFormChange} className="form-control" placeholder="example@gmail.com" />
                {errors.email && <small className="invalid-field text-danger fw-semibold mt-2">{errors.email}</small>}

            </div>

            <div className="col-md-6 mb-3">
                <label className="form-label">Phone Number<span>*</span></label>
                <div className="row gx-1">
                    <div className="col-2">
                        <select className='form-select' name='countryCode' value={form.countryCode} disabled readOnly>
                            {countryCode?.map((item => (
                                            <option value={item.isd_code} key={item.id}>{item.isd_code}</option>
                                        )))}
                        </select>
                    </div>
                    <div className="col-10">
                        <input type="text" name='mobileNumber' value={form.mobileNumber} onChange={handleFormChange} className="form-control" placeholder="Enter mobile number" />
                    </div>
                </div>
                {errors.mobileNumber && <small className="invalid-field text-danger fw-semibold mt-2">{errors.mobileNumber}</small>}


            </div>

            <div className="col-lg-6">
                <label className="form-label">Class</label>
                <select name="class" value={form.class} onChange={handleFormChange} className='form-select'>
                    <option value="">Select class</option>
                    {classes?.map((classItem) =>  <option key={classItem.id} value={classItem.id}>{classItem.name}</option>)}
                </select>
                {errors.class && <small className="invalid-field text-danger fw-semibold mt-2">{errors.class}</small>}

            </div>

            <div className="col-lg-6">
                <label className="form-label">School</label>
                <input type="text" name='school' value={form.school} onChange={handleFormChange} className="form-control" placeholder="Enter school name" />
                {errors.school && <small className="invalid-field text-danger fw-semibold mt-2">{errors.school}</small>}

            </div>

            <div className="col-md-12 text-end mt-3">
                {loading ? <button className="btn btn-default" disabled type="button">
                    <span className="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                    Submiting...</button> : <button type="submit" className="btn btn-default">Submit</button>}

            </div>
        </form>
    )
}

export default ReferalForm